module.exports = __webpack_public_path__ + "img/cxample_19.4a3926a6.png";